// Alphabetically sort an array of objects by some key,
// where the value of that key is a string
export const sortAlphaByKey = (a, b, key) => {
  const textA = a[key].toUpperCase();
  const textB = b[key].toUpperCase();
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};

// Sort an array of resources by their "order" array of _ids
export const orderById = (array, order) => {
  const _array = [...array];
  _array.sort(function(a, b) {
    const A = a._id;
    const B = b._id;

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1;
    } else {
      return -1;
    }
  });

  return _array;
};

export const isStrongPassword = pass => {
  var score = 0;
  if (!pass || pass.length < 8) {
    return score;
  }

  // award every unique letter until 5 repetitions
  var letters = {};
  for (var i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1;
    score += 5.0 / letters[pass[i]];
  }

  // bonus points for mixing it up
  var variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass)
  };

  let variationCount = 0;
  for (var check in variations) {
    variationCount += variations[check] === true ? 1 : 0;
  }
  score += (variationCount - 1) * 10;

  return score > 60;
};



// WEBPACK FOOTER //
// ./src/lib/index.js